import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import FilterName from '@/features/filter/v2/FilterName';
import Checkbox from '@/features/filter/v2/Checkbox';
import { allFilterPages } from '@/features/filter/static/filterUtil';

const LastStatus = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allOptionList, setAllOptionList] = useState([]);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allOptionList);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.LAST_STATUS]: dependentFilterList?.lastStatusList
	};

	const onFetchData = () => {
		let responseData = filterData[filterPageName];
		responseData = responseData?.map((item) => {
			return { id: item.id, name: item.name, count: item?.count };
		});
		setAllOptionList(responseData);
		setData(responseData);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allOptionList.filter((item) => item.name.toLowerCase().includes(e.target.value.toLowerCase()))
			: allOptionList;
		setData(searchResult);
	};

	return (
		<React.Fragment>
			<FilterName type="LAST_STATUS" />
			<Checkbox type="LAST_STATUS" data={data} handleSearch={handleSearch} />
		</React.Fragment>
	);
};

export default LastStatus;
